/**
 * Individual schedule attaches to one investor's own copy — a multi-sign document shares a
 * single copy across every signer, so there is no per-investor schedule to attach it to.
 */
export const scheduleCouplingDisabled = ({
	individualInstances,
}: {
	individualInstances: boolean | undefined;
}): boolean => individualInstances === false;
